import React from 'react';




class Footer extends React.Component {
    render(){

        return(
            <div id='footer'>
                <h6>26 abc lane <br></br> london <br></br> Sw13 5dx <br></br>+44 020 1234 5678</h6>

               <h6> <a href="https://www.instagram.com/"  target="_blank" rel="noopener noreferrer">Instagram</a><br></br>
                <a href=" https://twitter.com/"  target="_blank " rel="noopener noreferrer" >Twitter</a><br></br>
                <a href="https://www.termsfeed.com/blog/sample-terms-and-conditions-template/"  target="_blank" rel="noopener noreferrer">Terms and Conditions </a><br></br>
                <a href="https://www.termsfeed.com/blog/sample-privacy-policy-template/"  target="_blank" rel="noopener noreferrer">Privacy policy </a></h6>

                <br></br>
                <h6><a href="https://joannathedeveloper.netlify.app/" target="_blank" rel="noopener noreferrer">J.E.Kalema Web Applications</a> </h6>



             
            </div>
        )
    }
    
}

export default Footer